import * as actionTypes from 'modules/audits/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/audits/constants';
import { indexByProp } from 'utils/global';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {Object<string, import('modules/global/generic.types').Link>} AuditDashboardLinkReducer
 */
const initialState = {};

/**
 * @param {AuditDashboardLinkReducer} state
 * @param {import('modules/audits/types/dashboard').FetchAuditsSuccessAction} action
 * @returns {AuditDashboardLinkReducer}
 */
const fetchAudits = (state, { meta, payload }) => {
  if (meta.source === DASHBOARD_SOURCE) {
    return indexByProp('rel', payload.links);
  }
  return state;
};

/**
 * @returns {AuditDashboardLinkReducer}
 */
const clearIds = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_SUCCESS]: fetchAudits,
  [actionTypes.CLEAR_COLLECTION]: clearIds,
});
